<template>
    <transition name="fade">
        <div class="bind-phone-container">
            <div class="bind-main">
                <Icon type="md-close" class="close-icon" @click="close"></Icon>
                <div class="bind-bg"></div>
                <div class="bind-form-container">
                    <div class="title">绑定手机号</div>
                    <div class="description">
                        按相关法规要求，请绑定或关联手机号，绑定的手机号还可以用于登录衣创社区
                    </div>
                    <div class="form">
                        <div class="form-input-number">
                            <div class="prefix-areacode">
                                +86<Icon type="md-arrow-dropdown"></Icon>
                            </div>
                            <input type="number" placeholder="请输入手机号码" v-model="form.mobile">
                        </div>
                        <div class="form-input-code">
                            <div class="form-item">
                                <input type="number" placeholder="请输入手机验证码" v-model="form.code">
                            </div>
                            <div class="btn-code">
                                <sms-code :mobile="form.mobile"></sms-code>
                            </div>
                        </div>
                        <Button class="confirm-btn" @click="submit">确定</Button>
                    </div>
                    <div class="skip-btn" @click="close">暂不登录</div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import SmsCode from "@/components/SmsCode.vue";
import {
    CheckMobile,
} from "@/api/index.js"
export default{
    name:"BindPhone",
    components:{ SmsCode },
    props:{
    },
    data(){
        return{
            form:{
                mobile:'',
                code:''
            }
        }
    },
    mounted(){},
    methods:{
        submit() {
            if(this.form.mobile.length === 0) {
                this.$layer.msg(`请输入手机号`)
                return
            }
            if(this.form.code.length === 0) {
                this.$layer.msg(`请填写验证码`)
                return
            }
            this.$emit('on-submit', this.form)
        },
        close() {
            this.$emit('on-close')
        },
    }
}

</script>
<style lang="scss" scoped>
@import './bindphone.scss'
</style>
